export default __webpack_public_path__ + "static/media/CheckIcon.e5c22cae.svg";